module.exports = " <div class=\"fish-admin section\"> <h1 class=title>Fish</h1> <div class=fishes> <article class=\"fish media\" v-for=\"fish in fishes\"> <div class=media-left> <img v-bind:src=fishImg(fish) /> </div> <div class=media-content> <h2 class=subtitle>{{fish.en}} <small><em>{{fish.la}}</em></small></h2> </div> </article> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fishes.vue
 ** module id = 47
 ** module chunks = 1
 **/